export default __webpack_public_path__ + "static/media/slubne-sos.293bdaa8.md";